import * as React from 'react'
import { View, Section } from '@espoon-voltti/react-components/layout'
import { Title, Text } from '@espoon-voltti/react-components/elements'
import { ScrollTopOnMount } from '@espoon-voltti/react-voltti/components/scroll-to-top-on-mount'
import styled from 'styled-components'

const ContentSection = styled(Section)`
  padding-left: 20px;

  .title {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`

const MarginTop = styled.div`
  margin-top: 20px;
`

export const A11yReport: React.FC = () => (
  <View
    dataQa={'a11yreport'}
    subtitle={''}
    status={''}
    title={'Tämä on Espoon kaupungin saavutettavuusseloste'}
  >
    <ScrollTopOnMount />
    <Text display={'block'}>
      Tämä saavutettavuusseloste koskee Espoon kaupungin avustusjärjestelmää ja
      se on laadittu 9.3.2020 ja päivitetty 2.7.2021. Tämän digipalvelun
      saavutettavuuden on arvioinut Sanna Pudas, UX-suunnittelija.
    </Text>
    <MarginTop />
    <Title size={3}>Digipalvelun saavutettavuuden tila</Title>
    <Section>
      <p className="content-text">
        Täyttää kriittiset saavutettavuusvaatimukset
      </p>
    </Section>

    <ContentSection>
      <Title size={3}>
        1. Verkkosivusto ei ole vielä kaikilta osin vaatimusten mukainen
      </Title>

      <ContentSection>
        <Title size={4}>Havaittava</Title>

        <p className="content-text">
          <Text weight={'bold'}>Suomi.fi session päättyminen</Text>
        </p>

        <Title size={4}>Saavuttamaton sisältö ja sen puutteet</Title>
        <p className="content-text">
          Käyttäjä ei voi tietää milloin Suomi.fi sessio tulee päättymään. 30
          minuuttia kirjautumisesta sessio loppuu eikä sitä voi jatkaa, mutta
          sen päättymisestä tulee virheviesti kun lomakkeen täyttöä yritetään
          jatkaa. Tämän jälkeen lomake tyhjenee ja täyttö alkaa alusta.
          Luonnoksen työstäminen ja osittain täytetyn lomakkeen tallennus on
          järjestelmän kehittämissuunnitelmissa
        </p>

        <Title size={4}>Saavutettavuusvaatimukset jotka eivät täyty</Title>
        <p className="content-text">
          1.4.10 Responsiivisuus - MVP:tä ei ole tehty vielä responsiivisessa
          muodossa
        </p>
      </ContentSection>
      <ContentSection>
        <Title size={4}>Hallittava</Title>
        <p className="content-text">
          <Text weight={'bold'}>
            Näppäimistöllä etenemistä ei ole vielä testattu koko järjestelmässä
          </Text>
        </p>
        <Title size={4}>Saavuttamaton sisältö ja sen puutteet</Title>
        <p className="content-text">
          Kevyttä testausta on tehty, mutta järjestelmällinen koko järjestelmän
          testaaminen on työn alla. Järjestelmä on kuitenkin koko ajan
          sellaisessa muutoksessa että uusia ongelmia voi tulla esiin.
        </p>
        <Title size={4}>Saavutettavuusvaatimukset jotka eivät täyty </Title>
        <p className="content-text">
          2.2.1 Säädettävä ajoitus - tämä rajoitus tulee Suomi.fi:stä
        </p>
      </ContentSection>
      <ContentSection>
        <Title size={4}>Ymmärrettävä</Title>
        <p className="content-text">
          <Text>
            Järjestelmä ei vie käyttäjää korjattavien kenttien kohdalle eikä
            virhelistausta näytetä sivun lopussa. Virhe kerrotaan ja näytetään
            kentän kohdalla.
          </Text>
        </p>
        <Title size={4}>Saavuttamaton sisältö ja sen puutteet</Title>
        <p className="content-text">Tunnistetut ongelmapaikat on korjattu.</p>
        <Title size={4}>Saavutettavuusvaatimukset jotka eivät täyty </Title>
        <p className="content-text">3.3.3 Virheen korjausehdotus</p>
      </ContentSection>
      <ContentSection>
        <Title size={4}>Toimintavarma</Title>
        <p className="content-text">
          <Text weight={'bold'}>
            Osa Html-elementeistä ei ole oikein nimettyjä.
          </Text>
        </p>
        <Title size={4}>Saavuttamaton sisältö ja sen puutteet</Title>
        <p className="content-text">-</p>
        <Title size={4}>Saavutettavuusvaatimukset jotka eivät täyty </Title>
        <p className="content-text">-</p>
      </ContentSection>
    </ContentSection>

    <ContentSection>
      <Title size={3}>
        Huomasitko saavutettavuuspuutteen digipalvelussamme?
      </Title>
      <ContentSection>
        <Text display={'block'}>
          Kerro se meille ja teemme parhaamme puutteen korjaamiseksi
        </Text>
        <MarginTop />
        <Text display={'block'} weight={'bold'}>
          Verkkolomakkeella{' '}
        </Text>
        <a
          href="https://easiointi.espoo.fi/eFeedback/fi/Feedback/20-S%C3%A4hk%C3%B6iset%20asiointipalvelut"
          target="blank"
        >
          https://easiointi.espoo.fi/eFeedback/fi/Feedback/20-S%C3%A4hk%C3%B6iset%20asiointipalvelut{' '}
        </a>
        <Text display={'block'} weight={'bold'}>
          Sähköpostilla{' '}
        </Text>
        <a href="mailto:nuoriso@espoo.fi" target="blank">
          nuoriso@espoo.fi
        </a>
        {' tai '}
        <a href="mailto:kulttuuripalvelut@espoo.fi" target="blank">
          kulttuuripalvelut@espoo.fi{' '}
        </a>
        {' tai '}
        <a href="mailto:liikuntapaikkavaraukset@espoo.fi" target="blank">
          liikuntapaikkavaraukset@espoo.fi{' '}
        </a>
        <Text display={'block'}>
          Espoon asiointipisteissä saa apua hakemusten tekemiseen.
        </Text>
      </ContentSection>
    </ContentSection>
    <ContentSection>
      <Title size={3}>Valvontaviranomainen</Title>
      <ContentSection>
        <Text display={'block'}>
          Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta
          meille eli sivuston ylläpitäjälle. Vastauksessa voi mennä 14 päivää.
          Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta
          lainkaan kahden viikon aikana,{' '}
          <a
            href="https://www.saavutettavuusvaatimukset.fi/oikeutesi/"
            target="blank"
          >
            voit tehdä ilmoituksen Etelä-Suomen aluehallintovirastoon.
          </a>{' '}
          Etelä-Suomen aluehallintoviraston sivulla kerrotaan tarkasti, miten
          ilmoituksen voi tehdä ja miten asia käsitellään.
        </Text>

        <MarginTop />
        <Text display={'block'} weight={'bold'}>
          Valvontaviranomaisen yhteystiedot
        </Text>
        <Text display={'block'}>Etelä-Suomen aluehallintovirasto</Text>
        <Text display={'block'}>Saavutettavuuden valvonnan yksikkö</Text>
        <Text display={'block'}>www.saavutettavuusvaatimukset.fi</Text>
        <Text display={'block'}>saavutettavuus(at)avi.fi</Text>
        <Text display={'block'}>puhelinnumero vaihde 0295 016 000</Text>
      </ContentSection>
    </ContentSection>
    <ContentSection>
      <Title size={3}>Teemme työtä saavutettavuuden parantamiseksi</Title>
      <ContentSection>
        <Section>
          <Text display={'block'}>
            Digipalveluistamme on tehty saavutettavuusarviointi
            saavutettavuusvaatimukset.fi-listauksen mukaisesti, testauksen apuna
            ei ole käytetty näkövammaisia testikäyttäjiä.
          </Text>
        </Section>
        <Section>
          <Text display={'block'}>
            Olemme sitoutuneet digipalveluiden saavutettavuuden parantamiseen.
          </Text>
        </Section>
        <Section>
          <Text display={'block'}>
            Tarjoamme tukea käyttäjille, joille digipalvelut eivät ole
            saavutettavissa. Henkilökohtaista apua saat Espoon kaupungin
            asiointipisteistä.
          </Text>
        </Section>
        <Section>
          <Text weight={'bold'}>Tämä verkkosivusto/sovellus on julkaistu</Text>
          <Text display={'block'}>3.1.2019 klo 9:00</Text>
        </Section>
      </ContentSection>
    </ContentSection>
  </View>
)
